import React, { Component, useEffect, UseEffect } from 'react';
import * as firebase from 'firebase';
import { NavBarGuest, NavBarAffiliate, NavBarUser } from '../view/NavBar';
import '../view/css/ProfileSettings.css';
import { ProfileSettingsSubscriptions } from '../view/ProfileSettingSubscriptions';
import { ProfileSettingsTags } from '../view/ProfileSettingTags';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link
} from "react-router-dom";
import { Eventfeed2 } from './eventfeed2.js'
import '../view/css/Feed.css';
import moment from 'moment';
import { Discovery } from './Discovery';
import Delayed from '../view/Delayed';

export const Eventfeed = () => {
    const looping_check = () => {
        console.log("i am looping");
    }

    const [type_1, setType] = React.useState("");
    const [subs, setSubs] = React.useState([]);
    const [eventy, setEvents] = React.useState([]);
    const [stop_store_event, setStore] = React.useState(false);
    const [subs_collect, setStop] = React.useState(false);
    const [stop_collect, setCol] = React.useState(false);
    const [empty, setFeed] = React.useState(false);
    const [is_affiliate, setAffiliate] = React.useState(false);
    const [feed_page, setPage] = React.useState(true);
    const [clicked_feed, clickedfeed] = React.useState(true);
    const [feed_color, setColor] = React.useState("feedclicked");
    const [disc_color, setDColor] = React.useState("feeddisc");
    const [userLoaded, setUserLoaded] = React.useState(false);
    const [current_affiliate, setAf] = React.useState("");
    const [no_feed, setNone] = React.useState(false);
    const [eventy_arr, setEventsArr] = React.useState([]);

    const firestore = firebase.firestore();
    const user = firebase.auth().currentUser;

    useEffect(() => {
        runThis();
    }, []);

    useEffect(() => {
        if (!subs_collect) {
            collect_subs();
        }
        if (!stop_store_event && subs_collect) {
            get_events();
            check_if_true();
        }


    });

    const runThis = () => {
        if (user) {
            const db = firestore.collection("Users").doc(user.email);
            const doc = db.get().then(function (doc) {
                if (doc.exists) {
                    setType(doc.data().type)
                    setUserLoaded(true);
                    setAf(doc.data().email);
                    if (doc.data().type == "Affiliate") {
                        setAffiliate(true);
                    }
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        }
    }

    const collect_subs = () => {
        //console.log("IM HERRRRRRE")

        if (user) {
            //console.log("I ENTER SUBS")

            const db = firestore.collection("Users").doc(user.email);

            const test = db.get().then(function (doc) {
                if (doc.exists) {
                    if (doc.data().type == "Affiliate") {
                        setAffiliate(true);
                    }
                    setSubs(doc.data().subscriptions);


                    setStop(true);
                }
            });
        }
    }

    const check_if_true = () => {
        if (eventy.length > 0) {
            setNone(false);
        }
        else {
            setNone(true);
        }
    }

    const get_events = () => {
        const array_event = [];
        var stop_rend = false;
        const today_date = moment(new Date().now);

        const ab = firestore.collection("Event");
        const query = ab.orderBy("event_start");
        query.get().then(data => {
            if (!stop_rend) {
                data.forEach(doc => {
                    if (subs.length !== undefined) {
                        for (var i = 0; i < subs.length; i++) {

                            const doccer = doc.data();
                            const start_date = moment(doccer.event_start.toDate());
                            const end_date = moment(doccer.event_end.toDate());
                            const sub_name = subs[i];

                            if (doccer.Affiliate === sub_name && ((start_date.isSameOrAfter(today_date)) || (end_date.isAfter(today_date)))) {
                                const aff = firestore.collection("Users").doc(sub_name);
                                aff.get().then(doc => {
                                    array_event.push({
                                        title: doccer.event_title,
                                        location: doccer.location,
                                        description: doccer.description,
                                        start: start_date.format("MMM D, YYYY [at] h:mm a"),
                                        end: end_date.format("MMM D, YYYY [at] h:mm a"),
                                        tags: doccer.tags,
                                        affiliate: doccer.username,
                                        email: doccer.Affiliate,
                                        pictures: doccer.picture
                                    })
                                    let unique = array_event.filter((e, i) => array_event.indexOf(e) === i);
                                    // stop_rend = true;
                                    setEvents(unique)
                                })
                            }
                            stop_rend = true;
                        }
                    }
                })
            }
        })
        setStore(true);
    }

    const set_feed_page = () => {
        setPage(true);
        setColor("feedclicked");
        setDColor("feeddisc");
    }

    const set_discovery = () => {
        setPage(false);
        setColor("feedcomp");
        setDColor("feedclicked");
    }

    const see_Array = () => {
        console.log(subs);
        console.log(eventy);
    }

    const populated = () => {
        if (eventy.length > 0) {
            console.log("THIS IS POPULATED");
        }
    }

    return (
        <div className="firstevent" >
            {!userLoaded && runThis()}
            {type_1 === "" ? <NavBarGuest /> : type_1 === "Student" ? <NavBarUser /> : <NavBarAffiliate />}
            {/*<button onClick={see_Array}>Test</button>*/}
            {/*<button onClick={collect_subs}> click for subs</button>*/}
            {/*<button onClick={get_events}> click for events </button>*/}
            {/*!subs_collect && collect_subs()*/}
            {/*!stop_store_event && subs_collect && get_events()*/}

            <div className="circlecontainer">
                {<div onClick={set_feed_page} className={feed_color}> Feed </div>}
                {!is_affiliate && <div onClick={set_discovery} className={disc_color}> Discovery </div>}
            </div>
            <Delayed waitBeforeShow={1000}>
                {feed_page && eventy.length === 0 && !is_affiliate && <h2 className="warning"> Please subscribe to affiliates to have a feed </h2>}
                {feed_page && eventy.length === 0 && is_affiliate && <h2 className="warning"> Please add some posts to have a feed</h2>}
                {/* <h1 > {subs.map(subs => (<span>  {subs}</span>))} </h1>*/}
            </Delayed>
            {feed_page && eventy.map(subs => (
                <Eventfeed2 noFetchData={get_events} title={subs.title} email={subs.email} description={subs.description} location={subs.location} start={subs.start} affiliate={subs.affiliate} picture={subs.pictures} end={subs.end} tags={subs.tags} check_affiliate={is_affiliate} inaffiliate_view={false} />
            ))}

            {!feed_page && <Discovery />}


        </div>
    )
}